import React from 'react'
import Title from '../title/Title'

const CustomPanel = (props) => {
  let { uischema, children, config } = props
  let { layoutDesign = 1 } = uischema

  if (layoutDesign === 1) {
    return (
      <div
        style={{
          padding: uischema.layoutPadding ?? '.5rem',
          margin: uischema.layoutMargin,
          backgroundColor: uischema.panelColor ?? '',
          minWidth: uischema.minWidth,
          maxWidth: uischema.maxWidth,
        }}
      >
        {(uischema.titleType === 'value' || uischema.title) && (
          <>
            <Title {...props} />
            <hr className="my-1" />
          </>
        )}
        {children}
      </div>
    )
  }

  return (
    <fieldset
      className="scheduler-border row"
      style={{
        padding: uischema.layoutPadding ?? '.5rem',
        margin: uischema.layoutMargin,
        backgroundColor: uischema.panelColor ?? '',
        minWidth: uischema.minWidth,
        maxWidth: uischema.maxWidth,
      }}
    >
      <legend
        className="scheduler-border"
        style={{
          fontSize: '16px',
        }}
      >
        <Title {...props} />
      </legend>
      <div className="w-100 mx-auto">{children}</div>
    </fieldset>
  )
}

export default CustomPanel
